<template>
  <div class="app-actions">
    <ElButton
      v-for="action in validPublishActions"
      :key="action"
      size="mini"
      class="app-actions__action-btn"
      :type="actionButtons[action]"
      @click.native="showActionModal(action)"
    >
      {{ getActionTitle(action) }}
    </ElButton>

    <AppActionModal
      v-if="modalAction"
      v-model="actionModal"
      :title="getActionTitle(modalAction)"
      :action-name="modalAction"
    />
  </div>
</template>

<script>
import AppActionModal from './AppActionModal';
import { APP_DETAILS } from '@/store/types';
import { mapGetters } from 'vuex';
import modal from '@/mixins/modal';

export default {
  name: 'AppActions',

  components: { AppActionModal },

  mixins: [modal],

  data() {
    return {
      actionModal: false,
      modalAction: '',
    };
  },

  computed: {
    ...mapGetters({ app: APP_DETAILS }),

    actionButtons() {
      return {
        publish_request: 'primary',
        cancel_publish_request: 'default',
        warning_removal_request: 'warning',
        cancel_warning_removal_request: 'default',
        suspension_removal_request: 'warning',
        cancel_suspension_removal_request: 'default',
        publish: 'primary',
        unpublish: 'danger',
        autopublish: 'default',
        cancel_autopublish: 'default',
        hide: 'default',
      };
    },

    validPublishActions() {
      if (!this.app.publishActions) return [];
      return this.app.publishActions.filter(
        action => this.actionButtons[action],
      );
    },
  },

  methods: {
    showActionModal(action) {
      this.modalAction = action;
      this.openModal('actionModal');
    },

    getActionTitle(action) {
      if (!action) {
        return '';
      }

      return this.$t(`APP.ACTIONS.${action.toUpperCase()}_TITLE`);
    },
  },
};
</script>

<style lang="scss">
.app-actions {
  $block: &;

  &__action-btn {
    @include breakpoint(small only) {
      margin-top: $global-margin / 2;
      margin-left: 0 !important;
      margin-right: $global-margin;

      @include rtl() {
        margin-right: 0 !important;
        margin-left: $global-margin;
      }
    }

    &.el-button--primary,
    &.el-button--warning,
    &.el-button--danger {
      border: 0;
    }
  }
}
</style>
